export default __webpack_public_path__ + "static/media/iconPolygonBlack.b52299dd.svg";